import { useStores } from '@/hooks/use-stores';
import { useMeasurement } from '@/hooks/useMeasurement';
import { DeviceType } from '@/constants/deviceTypeEnum';

import { Entity } from '../../../NodeWidget.types';
import { areArraysEqual, buildPhysicalSchema, DEFAULT_MODEL_IDS } from '../../EditAssetDrawer.utils';

export const useInitialValues = (entity: Entity) => {
  const { pidEditStore } = useStores();
  const { tvalue } = useMeasurement();
  const connectTo = pidEditStore.getDraftDeviceWithoutPipesByIdToDevices(entity.deviceId);
  const connectFrom = pidEditStore.getDraftDeviceWithoutPipesByIdFromDevices(entity.deviceId);
  const initialDeviceModelId = entity.deviceModelId ?? DEFAULT_MODEL_IDS[entity.deviceType];

  return {
    name: entity.name,
    deviceType: entity.deviceType,
    deviceModelId: initialDeviceModelId,
    capacity: tvalue(entity.capacity, 'liter'),
    connectTo,
    connectFrom,
  };
};

export const mapFormValuesToPayload = (values, entity, initialValues, tvalue) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { measurementSystem } = useMeasurement();

  const inputUnit = measurementSystem === 'METRIC' ? 'liter' : 'gallon';
  return {
    name: values.name,
    deviceModelId: values.deviceModelId,
    deviceType: values.deviceType,
    attributes: {
      capacity: Math.round(tvalue(values.capacity, inputUnit, 'METRIC', measurementSystem)),
    },

    ...(entity?.deviceId
      ? !areArraysEqual(initialValues.connectTo, values.connectTo) && {
          physicalSchema: buildPhysicalSchema(entity, {
            toDevices: values.connectTo,
          }),
        }
      : {
          to: values.connectTo,
          from: values.connectFrom,
        }),
  };
};

export const getTankTypeOptions = t => [
  { value: DeviceType.DryAirTank, label: t('Dry Air Tank') },
  { value: DeviceType.WetAirTank, label: t('Wet Air Tank') },
];
